import { render, staticRenderFns } from "./yi_aq_settled.vue?vue&type=template&id=2f9cca7a&scoped=true"
import script from "./yi_aq_settled.vue?vue&type=script&lang=js"
export * from "./yi_aq_settled.vue?vue&type=script&lang=js"
import style0 from "./yi_aq_settled.vue?vue&type=style&index=0&id=2f9cca7a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9cca7a",
  null
  
)

export default component.exports